import { io } from "socket.io-client";

/**
 * @deprecated This socket instance is being phased out in favor of the SocketContext.
 *
 * IMPORTANT: For new components, use `useSocket()` from SocketContext instead.
 *
 * Why?
 * - This socket instance is not automatically registered with the server
 * - The SocketContext socket auto-registers on connect and handles rooms properly
 * - Using two socket instances causes duplicate connections and event listeners
 *
 * Migration guide:
 * ```
 * // Old (deprecated)
 * import { socket } from "../sockets";
 *
 * // New (recommended)
 * import { useSocket } from "../context/SocketContext";
 *
 * function MyComponent() {
 *   const socket = useSocket();
 *   // ... use socket
 * }
 * ```
 *
 * This file is kept for backward compatibility with:
 * - validateToken.js (registerWithServer)
 * - AppBar.js (disconnectWithServer)
 * - Legacy components not yet migrated
 */

const hostname = window.location.hostname;

let SOCKET_URL = "";
let SOCKET_PATH = "";

/**
 * LOCAL
 */
if (hostname === "localhost" || hostname === "127.0.0.1") {
  SOCKET_URL = "http://localhost:3001";
  SOCKET_PATH = "/socket.io/";

  /**
   * DEV
   */
} else if (hostname.includes("dev")) {
  SOCKET_URL = "https://dev-backend.flownect.com";
  SOCKET_PATH = "/flownect-api/socket.io/";

  /**
   * PRODUCCIÓN
   */
} else {
  SOCKET_URL = "https://backend.flownect.com";
  SOCKET_PATH = "/flownect-api/socket.io/";
}

export const socket = io(SOCKET_URL, {
  path: SOCKET_PATH,
  transports: ["websocket", "polling"],
});

export function registerWithServer(uid) {
  socket.emit("register", uid);
}

export function disconnectWithServer() {
  socket.emit("user_disconnect");
}
